module.exports = __webpack_public_path__ + "static/img/terms-header.568964c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/terms-header.jpg
// module id = kFnJ
// module chunks = 0